import { date, showAlert } from '../../../lib/helpers';
import {headers, search, dataBroadcastLogStatus } from './attributes';


export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialogResend: false,
    headers,
    search,
    selectedRow: '',
    bdateFormatted: '',
    dateMenuBDate: false,
    rdateFormatted: '',
    dateMenuRDate: false,
    itemsStatus: dataBroadcastLogStatus,
    dataResend: null,
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.broadcast.broadcastEmail.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.broadcast.broadcastEmail.flashError;
      },
      set() {
        this.$store.commit('broadcast/broadcastEmail/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.broadcast.broadcastEmail.errors;
    },
    loading() {
      return this.$store.state.broadcast.broadcastEmail.loading;
    },
    merchants() {
      return this.$store.state.broadcast.broadcastEmail.allMerchants;
    },
    totalPage() {
      return this.$store.state.broadcast.broadcastEmail.totalPage;
    },
    totalMerchants() {
      return this.$store.state.broadcast.broadcastEmail.totalMerchants;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.broadcast_date': {
      handler() {
        this.bdateFormatted = this.formatDate(this.search.broadcast_date);
        this.getData();
      },
    },

    'search.resend_date': {
      handler() {
        this.rdateFormatted = this.formatDate(this.search.resend_date);
        this.getData();
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
  methods: {
    searchFilter(){
      this.options.page = 1;
      this.getData();
    },
    clearFilterData(field) {
      this.search[field] = ''; 
      this.getData(); 
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.aggregator_name = '';
      this.search.mid = '';
      this.search.email = '';
      this.search.subject = '';
      this.search.broadcast_date = null;
      this.search.status = '';
      this.search.resend_date = null;
      this.search.resend_counter = '';
      this.getData();
    },

    openDialogResend(data) {
      this.dialogResend = true;
      // eslint-disable-next-line no-underscore-dangle
      this.dataResend = data._id.$oid;
    },

    resend() {
      this.$store
        .dispatch('broadcast/broadcastEmail/resendBroadcast', {
          date,
          id: this.dataResend,
        })
        .then((res) => {
          if (res) {
            this.getData();
            showAlert(
              this.$store,
              'Resend email success !',
              'mdi-check-circle',
              'green'
            );
          }
        })
        .finally(() => {
          this.dialogResend = false;
          this.dataResend = null;
        });
    },

    getData() {
      this.$store.commit('broadcast/broadcastEmail/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('broadcast/broadcastEmail/fetchDataLog', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    closeFlash() {
      this.$store.commit('broadcast/broadcastEmail/setFlashErrorMessage', '');
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};